module.exports = __webpack_public_path__ + "img/PlaceIcon.1b3ef79d.svg";